import ProfileBlock from './ProfileBlock';
export default ProfileBlock;
